module.exports = __webpack_public_path__ + "static/img/09047B_1_C_20210223_LC.27d531b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/09047B_1_C_20210223_LC.png
// module id = zQJ3
// module chunks = 0